import Hotjar from "@hotjar/browser";
import { useEffect } from "react";

export const useInitializeHotjar = () => {
  useEffect(() => {
    const siteId = 6449506;
    const hotjarVersion = 6;

    if (process.env.NODE_ENV === "production") {
      Hotjar.init(siteId, hotjarVersion);
    }
  }, []);
};
